"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _axios = _interopRequireDefault(require("axios"));

var _axios2 = _interopRequireDefault(require("./axios.jsonp"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _default =
/*#__PURE__*/
function () {
  function _default(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2["default"])(this, _default);
    this.url = url;
    this.options = options;
  }

  (0, _createClass2["default"])(_default, [{
    key: "send",
    value: function send(data) {
      return this._send('post', data, this.options);
    }
  }, {
    key: "post",
    value: function post(data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options;
      return this._send('post', data, options);
    }
  }, {
    key: "put",
    value: function put(data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options;
      return this._send('put', data, options);
    }
  }, {
    key: "delete",
    value: function _delete(data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options;
      return this._delete('delete', options);
    }
  }, {
    key: "get",
    value: function get() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options;

      if (options.data && (0, _typeof2["default"])(options.data) === 'object') {
        // для отправки данных в URLSearchParams, их нужно отправлять через params
        options.params = _objectSpread({}, options.data, {}, options.params || {});
      }

      if (options.dataType === 'jsonp') {
        return (0, _axios["default"])(_objectSpread({
          url: this.url
        }, options, {}, this._getCancelToken(), {
          adapter: _axios2["default"]
        }));
      } else {
        return _axios["default"].get(this.url, _objectSpread({}, options, {}, this._getCancelToken()));
      }
    }
  }, {
    key: "_delete",
    value: function _delete() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var config = _objectSpread({}, options, {}, this._getCancelToken());

      return _axios["default"]["delete"](this.url, config);
    }
  }, {
    key: "_send",
    value: function _send() {
      var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'get';
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var config = _objectSpread({}, options, {}, this._getCancelToken());

      delete config.data;
      return _axios["default"][method](this.url, data, config);
    }
  }, {
    key: "_getCancelToken",
    value: function _getCancelToken() {
      var CancelToken = _axios["default"].CancelToken;
      this._cancelSource = CancelToken.source();
      return {
        cancelToken: this._cancelSource.token
      };
    }
  }, {
    key: "close",
    value: function close() {
      return this._cancelSource && this._cancelSource.cancel();
    }
  }]);
  return _default;
}();

exports["default"] = _default;